// @flow
module.exports = {
  REGISTRATION: '/user/registration',
  LOGIN: '/user/login',
  FORGOT_PASSWORD: '/forgot_password',
  RESET_PASSWORD: '/reset_password',
}
